(() => {
  const SELECTOR = ".slideshow.slideshow--shared-bg[data-shared-bg='true']";
  const NEXT_CLASS = "shared-bg--next-section";

  function getNextShopifySection(slideshowEl) {
    const sectionWrapper = slideshowEl.closest(".shopify-section");
    if (!sectionWrapper) return null;
    let next = sectionWrapper.nextElementSibling;
    while (next) {
      if (next.classList && next.classList.contains("shopify-section")) return next;
      next = next.nextElementSibling;
    }
    return null;
  }

  function updateOne(slideshowEl) {
    const nextSection = getNextShopifySection(slideshowEl);
    if (!nextSection) return;

    nextSection.classList.add(NEXT_CLASS);

    const height = Math.ceil(nextSection.getBoundingClientRect().height || 0);
    slideshowEl.style.setProperty("--slideshow-next-section-height", `${height}px`);
  }

  function updateAll() {
    document.querySelectorAll(SELECTOR).forEach(updateOne);
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateAll, { once: true });
  } else {
    updateAll();
  }
  // Re-run after all scripts are loaded — fixes Firefox/Swiper timing issue
  window.addEventListener("load", updateAll, { once: true });

  // Theme editor / section re-render support
  document.addEventListener("shopify:section:load", updateAll);
  document.addEventListener("shopify:section:reorder", updateAll);
  document.addEventListener("shopify:section:select", updateAll);
  document.addEventListener("shopify:section:deselect", updateAll);

  // Resize handling
  let raf = 0;
  window.addEventListener(
    "resize",
    () => {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(updateAll);
    },
    { passive: true }
  );
})();

